<ng-container *transloco="let t">
  <div class="radiology-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('radiology.patientHistory') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="patientHistory" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('radiology.radiologyFinding') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="radiologyFinding"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
